<script lang="ts">
	import ChevronRight from '$lib/assets/images/icons/chevron-right.svg?component';
	import { onMount } from 'svelte';
	import { fade } from 'svelte/transition';

	let showScrollButton = false;

	onMount(() => {
		const updateScroll = () => (showScrollButton = window.scrollY > 200);
		updateScroll();
		window.addEventListener('scroll', updateScroll);

		if (!window.Tawk_API) return null;

		// window.Tawk_API.customStyle = {
		// 	visibility: {
		// 		desktop: {
		// 			position: 'br',
		// 			xOffset: '60px',
		// 			yOffset: 20
		// 		},
		// 		mobile: {
		// 			position: 'br',
		// 			xOffset: 0,
		// 			yOffset: 0
		// 		},
		// 		bubble: {
		// 			rotate: '0deg',
		// 			xOffset: -20,
		// 			yOffset: 0
		// 		}
		// 	}
		// };
	});
</script>

{#if showScrollButton}
	<a
		transition:fade={{ duration: 200 }}
		class="fixed bottom-0 right-0 z-50 float-right border-[32px] border-primary border-l-transparent border-t-transparent md:border-[28px]"
		href="#"
	>
		<ChevronRight class="absolute left-1 block h-6 -rotate-90 stroke-white stroke-[6px]" />
	</a>
{/if}
